"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgAward = function SvgAward(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 12a8 8 0 014.861 14.354l1.13 8.514a1 1 0 01-1.505.99L24 33.165l-4.486 2.691a1 1 0 01-1.505-.989l1.13-8.513A8 8 0 0124 12zm0 16a7.978 7.978 0 01-2.985-.575l-.75 5.65 3.22-1.932a1 1 0 011.03 0l3.22 1.932-.749-5.65A7.978 7.978 0 0124 28zm0-14a6 6 0 103.19 11.082.784.784 0 01.137-.088A6 6 0 0024 14z",
    id: "award_svg__a"
  }));
};

var _default = SvgAward;
exports["default"] = _default;